import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initTracking, trackHeartbeat, trackPage } from "../lib/tracking";

let started = false;

export default function Tracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!started) {
      started = true;
      initTracking().then(() => trackPage(window.location.pathname));
      const onConsent = () => trackPage(window.location.pathname);
      window.addEventListener("mhm-consent", onConsent);
    }
    const t = setInterval(() => {
      if (document.visibilityState === "visible") trackHeartbeat(15);
    }, 15000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (started && window.__mhmLastPath && window.__mhmLastPath !== pathname) trackPage(pathname);
    window.__mhmLastPath = pathname;
  }, [pathname]);

  return null;
}
